import React from 'react';
import { Outlet } from 'react-router-dom';

const SpeakerHome = () => {
  return (
    <section className="app-route">
      <Outlet />
    </section>
  );
};

export default SpeakerHome;